import { Alert } from "@material-ui/lab";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { useSockets } from "../../../../../../Context/Context-Sockets/ContextSockets";

function StartMove(props) {
  const { locationAccess } = useSockets();
  const { startMove } = props;
  const handleClick = () => {
    document.getElementById("close-start-move").click();
    startMove();
  };

  const handlePush = () => {
    props.history.push("/foreman/how-allow-location");
  };

  return (
    <>
      <div
        className="modal fade"
        id="start-move"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="start-move-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="close-start-move"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                {!locationAccess ? (
                  <Alert severity="warning">
                    Please allow Geo-Location so the customer can track you on
                    the map.
                    <Link
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={handlePush}
                      className="pl-2 custom-link"
                    >
                      How?
                    </Link>
                  </Alert>
                ) : (
                  <Alert severity="success">
                    After start the move the customer can track your location on
                    the map.
                  </Alert>
                )}

                <h5 className="text-center pt-2" id="start-move-title">
                  Start Move
                </h5>

                <p className="pt-3 text-center">
                  Are you sure you want to start move ?
                </p>
                {/* <p className="pt-1 sub-title mb-1">Mover 1</p> */}
                {/* <div className="row">
                  <div className="col-12 col-sm-6">
                    <div className="form-group">
                      <label htmlFor="first-name" className="overline dark-grey-color">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="form-control small-font-size"
                        id="first-name"
                        placeholder="John"
                        value="John"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-6">
                    <div className="form-group">
                      <label htmlFor="last-name" className="overline dark-grey-color">
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control small-font-size"
                        id="last-name"
                        placeholder="Doe"
                        value="Doe"
                      />
                    </div>
                  </div>
                </div> */}
                {/* <div className="pt-2 pb-3 text-left">
                  <a href="" className="small-text-bold red-color add-new-btn">
                    <img src="../images/add-icon.svg" /> <span>Add New</span>
                  </a>
                </div> */}

                <div className="buttons-wrapper pt-2">
                  {/* <p className="text-center small-font-size pb-4 mb-3">
                    <span className="pr-3 align-baseline">
                      <img src="../images/alert-icon.svg" />
                    </span>
                    Don’t forget to edit price after adding new mover
                  </p> */}
                  <div className="row pt-1 pb-3">
                    <div className="col-12">
                      <button
                        onClick={handleClick}
                        className="custom-buton custom-buton-large w-100"
                      >
                        Start Move
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(StartMove);
